import clienteAxios from "../config/axios";

export async function getAbmAtributoProducto () {
    return clienteAxios.get(`/abmAtributoProduct`);
}

export async function getAbmAtributoProductoByProducto (tipPro, artCod) {
    return clienteAxios.get(`/abmAtributoProductoByProducto/${tipPro}/${artCod}`);
}
